/**
 * Opt-in header for live staff handoff. equility-api runs the handoff path
 * (person requests, the paused-AI gate, handoff routes) only for clients that
 * send it, and answers a handoff route without it with 400. Sent on every
 * user chat request and every `user/chat/sessions/:id/handoff|messages` call.
 */
export const CHAT_HANDOFF_HEADERS = { "X-Chat-Handoff": "1" } as const;

export const CHAT_HANDOFF_REQUEST_CONFIG = {
	headers: CHAT_HANDOFF_HEADERS,
};
